module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(/^(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(this.$store.state.previewImgUrl.split('.').pop())) ? _c('div', {
    staticClass: "posFixed"
  }, [_c('div', {
    staticClass: "posFixed ",
    on: {
      "click": _vm.closePreviewImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "big-img-box"
  }, [_c('video', {
    attrs: {
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getImageUrl(_vm.previewImgUrl, 1),
      "type": "video/mp4"
    }
  })])])]) : _c('div', [_c('div', {
    staticClass: "big-img-box"
  }, [_c('div', [_c('viewer', {
    ref: "viewer",
    staticClass: "viewer",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background-size": "contain",
      "background-repeat": "no-repeat",
      "background-position": "center",
      "background-color": "#3e5c9a"
    },
    attrs: {
      "images": _vm.pics,
      "options": _vm.options
    }
  }, _vm._l((_vm.pics), function(img, index) {
    return _c('img', {
      key: index,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "src": _vm.getImageUrl(img, index == _vm.single ? 1 : '')
      }
    })
  }), 0)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a23ac46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview-image-single.vue
// module id = JXxK
// module chunks = 6